import parse from "html-react-parser";
import Toastify from "toastify-js";
import "toastify-js/src/toastify.css";
import qs from "qs";
import moment from "moment";
import fileDownload from "js-file-download";

export const getToken = () => {
  let token = "";
  var localData = JSON.parse(localStorage.getItem("pos-user-data"));
  token = localData?.token;
  return token;
};

export const getStoreId = () => {
  const isStoreAdmin = window.location.pathname.includes("/store-admin");
  const localData = JSON.parse(localStorage.getItem("pos-user-data"));
  return isStoreAdmin ? localData?.selectedStoreId : null;
};

export const successMessage = async (text) => {
  if (text === null || text === undefined || text === "")
    text = "Data saved successfully!";
  Toastify({
    text: text,
    duration: 3000,
    close: true,
    gravity: "top",
    position: "right",
    avatar: "/icons/success_toast.png",
    style: {
      background: "#388e3c",
    },
  }).showToast();
};
export const successRedMessage = async (text) => {
  if (text === null || text === undefined || text === "")
    text = "Data saved successfully!";
  Toastify({
    text: text,
    duration: 3000,
    close: true,
    gravity: "top",
    position: "right",
    avatar: "/icons/icon_not.svg",
    style: {
      background: "#FEB019",
    },
  }).showToast();
};
export const infoMessage = async (text) => {
  if (text === null || text === undefined || text === "")
    text = "Data saved successfully!";
  Toastify({
    text: text,
    duration: 3000,
    close: true,
    gravity: "top",
    position: "right",
    avatar: "/icons/error_toast.png",
    style: {
      background: "#FEB019",
    },
  }).showToast();
};

export const errorMessage = async (text) => {
  if (text === null || text === undefined || text === "") text = "Error";
  Toastify({
    text: text,
    duration: 3000,
    close: true,
    gravity: "top",
    position: "right",
    avatar: "/icons/error_toast.png",
    style: {
      background: "#d32f2f",
    },
  }).showToast();
};

export const sortItems = (prev, curr, columnId) => {
  if (
    prev.original[columnId]?.toLowerCase() >
    curr.original[columnId]?.toLowerCase()
  ) {
    return 1;
  } else if (
    prev.original[columnId]?.toLowerCase() <
    curr.original[columnId]?.toLowerCase()
  ) {
    return -1;
  } else {
    return 0;
  }
};

export const sortNestedItems = (prev, curr, columnId, objectId) => {
  if (
    prev.original[columnId][objectId]?.toLowerCase() >
    curr.original[columnId][objectId]?.toLowerCase()
  ) {
    return 1;
  } else if (
    prev.original[columnId][objectId]?.toLowerCase() <
    curr.original[columnId][objectId]?.toLowerCase()
  ) {
    return -1;
  } else {
    return 0;
  }
};

export const sortStatus = (prev, curr) => {
  if (prev?.toLowerCase() > curr?.toLowerCase()) {
    return 1;
  } else if (prev?.toLowerCase() < curr?.toLowerCase()) {
    return -1;
  } else {
    return 0;
  }
};

const ErrorFormatter = (error) => {
  let errorString = "";

  if (error.response) {
    if (error.response.data.message) {
      errorString += error.response.data.message + "</br>";
    }
    if (error.response.data.errors !== null) {
      for (var err in error.response.data.errors) {
        errorString += error.response.data.errors[err];
      }
    } else if (!error.response.data.message) {
      errorString += "An error has occured!";
    }
  } else {
    errorString += "An error has occured!";
  }
  return parse(errorString);
};

export const arraySort = (data, key) => {
  return [...data].sort(function (a, b) {
    return a[key]?.toLowerCase().localeCompare(b[key]?.toLowerCase());
  });
};
export const priceValidator = {
  required: true,
  message: "Please enter a number with not more than two decimal places",
  rule: (value) => {
    return /^[-]?(\d*\.\d{1,2}|\d+)$/.test(value);
  },
};
export const costValidator = {
  required: true,
  message: "Please enter a number with not more than three decimal places",
  rule: (value) => {
    return /^[-]?(\d*\.\d{1,3}|\d+)$/.test(value);
  },
};

export const serializeParams = (params) => {
  return qs.stringify(params, { encode: true });
};

/**
 * Copies the provided text to the clipboard.
 *
 * @param {string} text - The text to be copied to the clipboard.
 * @returns {Promise<void>} A promise that resolves when the text has been successfully copied.
 * @throws Will throw an error if the text could not be copied.
 */
export const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    successMessage("Text has been successfully copied to the clipboard!");
  } catch (error) {
    errorMessage("Unable to copy text. Please try again.");
    console.error(error);
  }
};

/**
 * Saves an image from a given URL to the device with the specified file name.
 *
 * @param {string} url - The URL of the image to be saved.
 * @param {string} [fileName="myImage.png"] - The name of the file to save the image as. Defaults to "myImage.png".
 * @returns {Promise<void>} A promise that resolves when the image has been saved.
 */
export const saveImageToDevice = async (url, fileName = "myImage.png") => {
  const toDataURL = async (url) => {
    return fetch(url)
      .then((response) => {
        return response.blob();
      })
      .then((blob) => {
        return URL.createObjectURL(blob);
      });
  };

  const a = document.createElement("a");
  a.href = await toDataURL(url);
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

/**
 * Converts a date to a specified format.
 *
 * @param {Object} params - The parameters for the function.
 * @param {Date|string} params.date - The date to be converted.
 * @param {string} [params.format="yyy-MM-DD"] - The format to convert the date to.
 * @returns {string} The formatted date string.
 */
export const convertDate = ({ date, format = "yyy-MM-DD" }) => {
  return moment(date).format(format);
};

/**
 * Saves a file from the given response.
 *
 * @param {Object} params - The parameters for the function.
 * @param {Object} params.response - The response object containing the file data.
 * @param {string} [params.fileName="file"] - The name to save the file as.
 * @returns {Promise<void>} - A promise that resolves when the file is saved.
 */
export const saveFileHelper = async ({ response, fileName = "file" }) => {
  const contentType = response.headers["content-type"];

  fileDownload(response.data, fileName, contentType);
};

/**
 * Creates an iframe to load a blob URL and triggers the print dialog for the content.
 *
 * @param {Blob} blob - The blob object containing the content to print.
 */
export const printFileHelper = (blob) => {
  let blobURL = URL.createObjectURL(blob);
  let iframe = document.createElement("iframe"); //load content in an iframe to print later
  document.body.appendChild(iframe);
  iframe.style.display = "none";
  iframe.src = blobURL;
  iframe.onload = function () {
    setTimeout(function () {
      iframe.focus();
      iframe.contentWindow.print();
    }, 1);
  };
};

export const formatAmount = (amount) => {
  if (amount === null || amount === undefined) return "$ 0.00";
  if (amount < 0) {
    return `-$${Math.abs(amount).toFixed(2)}`;
  } else {
    return typeof amount === "string"
      ? `$${Number(amount).toFixed(2)}`
      : `$${amount.toFixed(2)}`;
  }
};

export const getDateRangeAsString = (dateRange) => {
  const startDate = moment(dateRange.startDate).format("YYYY-MM-DD");
  const endDate = moment(dateRange.endDate).format("YYYY-MM-DD");
  return `${startDate} - ${endDate}`;
};
